<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <h3>Categoria: {{category.description}} ({{category.category_product_id}})</h3>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-12">

                            <div class="form-group">
                                <label for="file">Foto</label>
                                <input type="file" id="file" name="file">
                                <p class="help-block">Suba a foto da categoria.</p>
                            </div>
                        </div>
                    </div>
                    <a class="btn btn-success" @click="save">Salvar</a>
                    <router-link to="/categoryProduct" class="btn btn-info">Voltar</router-link>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                category: {}
            }
        },
        props: {},
        mounted: function () {
            const id = this.$route.params.id;
            const api = this.$store.state.api;
            const self = this;

            self.$http.get(api + 'categoryProduct/' + id + '?disabled=true')
                .then((response) => {
                    this.category = response.data;
                })
                .catch((error) => {
                    self.$message(null, 'Ocorreu um erro ao buscar as informações da Categoria do Produto');
                });
        },
        methods: {
            save() {
                const id   = this.$route.params.id;
                const api  = this.$store.state.api;
                const self = this;

                let data  = new FormData();
                let file  = document.getElementById('file');

                data.append('id', id);
                data.append('file', (file.files[0]) ? file.files[0] : null);

                self.$http.post(api + 'categoryProduct/uploadImage', data)
                    .then(function (res) {
                        self.$message('Sucesso', 'Foto da categoria atualizada com sucesso', 'success')
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li class="m-t-sm m-b-sm">' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    })
            }

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/CategoryProduct/Edit.vue